<template>
  	<div>
		<div class="page-wrapper">
			<article>
				<header class="article-head">
					<h1 class="title title--main">{{ $t('terms.comingSoon') }}</h1>
				</header>
			</article>
		</div>
  	</div>
</template>


<script>
import Introducer from '@/components/utils/Introducer.vue'

export default {
	components: { Introducer },

	mounted () {	
	},

	data () {
		 return {
		 }
	},

	computed: {

	},

	methods: {
	}
};
</script>

<style lang="scss">
	@import url('https://fonts.googleapis.com/css?family=Libre+Baskerville:400i&display=swap');

	$quote-font: 'Libre Baskerville', serif;
	$news-font : 'Montserrat', sans-serif;

	//breakpoints
	$screen-sm: 576px;
	$screen-md: 768px;
	$screen-lg:	992px;
	$screen-xl:	1280px;

	//breakpoints mixin

	@mixin media-breakpoint-up($class) {

	  @if $class == sm {
	    @media (min-width: $screen-sm) { @content; }
	  }

	  @else if $class == md {
	    @media (min-width: $screen-md) { @content; }
	  }

	  @else if $class == lg {
	    @media (min-width: $screen-lg) { @content; }
	  }

	   @else if $class == xl {
	    @media (min-width: $screen-xl) { @content; }
	  }

	  @else {
	    @warn "Breakpoint mixin supports: xs, sm, md, lg";
	  }
	}
//main article font
@mixin newsFont($colour: false, $size: false, $weight: false,  $lh: false) {
    font-family: $news-font, Helvetica, Arial, sans-serif;
    //@if $size { font-size: $size; }
    @if $colour { color: $colour; }
    @if $size { font-size: $size; }
    @if $weight { font-weight: $weight; }
    @if $lh { line-height: $lh; }
}

	.article-head {
		margin: 40px 0;
		padding: 0 0 20px;
		border-bottom: 1px solid #ccc;
	}
	.article-head__top {
		display: flex;
		justify-content: space-between;
	}
	.article-details {
		list-style-type: none;
		display: flex;
		margin-bottom: 2em;
		@include newsFont (#000, 12px, 400, 18px);
		@include media-breakpoint-up(sm) {
			@include newsFont (#000, 16px, 400, 20px);
		}
	}
	.article-details__item {
		margin-right: 1em;
		display: flex;
		&:after {
			content: '|';
			margin-left: 1em;
		}
		&:last-child {
			&:after {
				content: none;
			}
		}
		&--calendar {
			&:before {
				content: url(./../../assets/calendar.svg);
				width: 17px;
				height: 17px;
				margin-right: 10px;
			}
		}
	}
	.social-links {
		list-style-type: none;
		display: flex;
	}
	.social-links__item {
		margin-left: 10px;
	}
	.title {
		margin-bottom: 1em;
	}
	.title--main {
		@include newsFont (#000, 20px, 500, 30px);
		text-transform: uppercase;
		margin-bottom: 1em;
		@include media-breakpoint-up(sm) {
			@include newsFont (#000, 27px, 200, 40px);
		}
		@include media-breakpoint-up(lg) {
			@include newsFont (#000, 48px, 200, 52px);
			width: 75%;
		}
	}
	.title--secondary {
		@include newsFont (#000, 22px, 400, 26px);
	}
	.title--sub {
		@include newsFont (#000, 18px, 700, 20px);
	}
	.link {
		color: #e02428;
		word-break: break-all;
		font-weight: 400;
	}
	.link--hidden {
		color: #000;
	}
	p {
		margin-bottom: 2em;
		line-height: 2em;
		font-weight: 300;
	}
	.quote {
		display: flex;
		font-weight: 300;
		line-height: 2em;
		margin-left: 0;
		margin-bottom: 40px;
		margin-top: 0;
	}

	.copyright {
		@include newsFont (#000, 14px, 400, 20px);
		font-style: italic;
	}
	.article-foot {
		background: #f7f7f7;
		padding: 30px 30px 5px;
		margin-bottom: 25px;
	}
</style>
